import { registerPropertyManagerSection } from '@/core';
import ReferencePointPropertySection from '@/components/editor/property-manager/reference/ReferencePointPropertySection.vue';

//------ 参考点属性面板注册修复 开始------
/**
 * @description 注册“参考几何体 > 基准点”PropertyManager 面板。
 * 说明：
 * 1. 该入口必须绑定 `ReferencePointPropertySection.vue`，用于参考点命令的选择/模式/参数交互；
 * 2. 禁止错误绑定到草图点编辑面板（`PointPropertySection.vue`）。
 */
registerPropertyManagerSection({
  id: 'reference-point',
  title: '参考点',
  order: 36,
  component: ReferencePointPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    if (context.activeCommand === 'geometry-reference-point') {
      return true;
    }
    return Boolean(context.referencePointActive);
  },
  onConfirm: (context) => {
    context.submitReferencePoint?.();
  },
  onCancel: (context) => {
    context.cancelReferencePoint?.();
  },
});
//------ 参考点属性面板注册修复 结束------
